import { FormattedMessage, useIntl } from "react-intl";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";

// Enums
import icons from "enums/icons";
import { urlPaths } from "enums/urlPaths";

// Utils
import { buildParamsString } from "utils";

// Components
import CustomIcon from "components/CustomIcon";
import { Box, Typography } from "@mui/material";
import { CardMessageWrapper, CardMessage } from "components/Message";

const ChartErrorMessage = ({ fromInsights = false }: { fromInsights?: boolean }) => {
    const intl = useIntl();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { pathname, search } = useLocation();

    // Url params
    const { companyId } = useParams();
    const projectId = searchParams.get("projectId");
    const insightId = searchParams.get("insightId");
    const briefId = searchParams.get("briefId");
    const searchAiId = searchParams.get("searchAiId");

    const handleNavigateToSetTeam = () => {
        const queryParams = buildParamsString({ projectId, insightId, briefId, searchAiId });
        const urlParams = `${companyId}?${queryParams}`;
        navigate(`${urlPaths.Team}/${urlParams}`, {
            state: {
                from: `${pathname}${search}`,
            },
        });
    };

    return (
        <CardMessageWrapper sx={{ position: "relative !important" }}>
            <CardMessage
                sx={{ maxWidth: "750px !important" }}
                title={
                    <Box display="flex" alignItems="center">
                        <CustomIcon
                            icon={icons.circledExclamationSign}
                            sx={{ fontSize: 20, color: "common.white", mr: 1 }}
                        />
                        <Typography sx={{ fontSize: 20, fontWeight: 600 }}>
                            {intl.formatMessage({
                                id: fromInsights
                                    ? "projection.insights.noBoardError.title"
                                    : "talent.people.noBoardError.title",
                            })}
                        </Typography>
                    </Box>
                }
                content={
                    <FormattedMessage
                        id={
                            fromInsights
                                ? "projection.insights.noBoardError.content"
                                : "talent.people.noBoardError.content"
                        }
                    />
                }
                actions={[
                    {
                        label: intl.formatMessage({
                            id: "projection.insights.noBoardError.button",
                        }),
                        onClickAction: handleNavigateToSetTeam,
                    },
                ]}
            />
        </CardMessageWrapper>
    );
};

export default ChartErrorMessage;
